import React from "react";
import { IBusinessMobileApps } from "../../shared/commonUtils";
interface IBussinessAppLink {
  data: IBusinessMobileApps;
}
const BussinessAppLink: React.FC<IBussinessAppLink> = (
  props: IBussinessAppLink
) => {
  const { data } = props;
  return (
    <div
      style={{ background: "var(--slider-background-color)" }}
      className="d-flex flex-column gap-1 align-items-center pt-30 pb-50 "
    >
      <div className="text-start mb-10">
        {data?.sectionTitle ? data?.sectionTitle : "تحميل تطبيق الجوال"}
      </div>
      <div class="d-flex gap-3">
        {Object.entries(data).map(([platform, details]) => (
          <a
            key={platform}
            href={details.url}
            rel="noreferrer"
            target="_blank"
            class="s-apps-icons-item"
            id="app-slot"
          >
            <img alt="appstore" src={details.image} height={40} width={135} />
          </a>
        ))}
        {/* <a
          href="https://apps.apple.com/app/id6741459702"
          rel="noreferrer"
          target="_blank"
          class="s-apps-icons-item"
          id="app-slot"
        >
          <img
            alt="appstore"
            src={require("../../assets/images/appstore.webp")}
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.watinia.ncdecommerce"
          rel="noreferrer"
          target="_blank"
          class="s-apps-icons-item"
          id="app-slot"
        >
          <img
            alt="googleplay"
            src={require("../../assets/images/googleplay.webp")}
          />
        </a> */}
      </div>
    </div>
  );
};

export default BussinessAppLink;
